export default __webpack_public_path__ + "static/media/1-6.a78f9994.jpg";